export default __webpack_public_path__ + "static/media/kabupaten-klaten.23cbaea0.png";